module.exports = __webpack_public_path__ + "img/pr-3.f6770d6f.png";